<script>
import tools from '../../tools/tools'
import RelatorioHTML from '../../utils/RelatorioHTML'
import ClientePesquisa from '../pesquisa/ClientePesquisa'
import CecInputData from '../../components/Cec/CecInputData'
import HistoricoCaixaDropdown from '../componentes/dropdown/HistoricoCaixaDropdown'
import CentroCustoDropDown from '../componentes/dropdown/CentroCustoDropDown'

export default {
  components: {
    ClientePesquisa,
    CecInputData,
    HistoricoCaixaDropdown,
    CentroCustoDropDown
  },
  data: function() {
    return {
      loading: false,
      tipoRelatorio: '1',
      DT1: tools.getFirstDayOfMonth(),
      DT2: tools.getDataAtual(),
      CONTAS_SELECIONADAS: [],
      LISTA_CONTAS: [],
      HISTORICO_ID: null,
      HISTORICO_NOME: '',
      CENTRO_CUSTO_ID: null,
      CENTRO_CUSTO_NOME: '',
      CLIENTE_ID: null,
      TIPO_MOV: '',
      opcoesRelatorio: [
        { value: '1', text: '1. Listagem Geral de Lançamentos (Analítico)' },
        { value: '2', text: '2. Acumulado por Histórico (Sintético)' },
        { value: '3', text: '3. Acumulado por Centro de Custo (Sintético)' },
        { value: '4', text: '4. Acumulado por Conta (Sintético)' },
        { value: '5', text: '5. Extrato de Despesas (Somente Débitos)' },
        { value: '6', text: '6. Extrato de Créditos (Somente Créditos)' },
        { value: '7', text: '7. Por Centro de Custo (Analítico Agrupado)' },
        { value: '8', text: '8. Por Histórico (Analítico Agrupado)' }
      ],
      opcoesTipo: [
        { value: '', text: 'Todos os Tipos' },
        { value: 'CREDITO', text: 'Somente Créditos' },
        { value: 'DEBITO', text: 'Somente Débitos' }
      ]
    }
  },
  computed: {
    isDark: function() {
      return this.$store.state.controle.isDark
    },
    filtrosHabilitados: function() {
      const t = this.tipoRelatorio
      return {
        historico: !['2', '8'].includes(t),
        centroCusto: !['3', '7'].includes(t),
        tipo: !['5', '6'].includes(t)
      }
    }
  },
  created: function() {
    this.carregarContas()
  },
  methods: {
    carregarContas: async function() {
      try {
        const body = {
          login: window.localStorage.getItem('login'),
          origem: 'web'
        }
        const response = await this.$http.post('/api/protected/conta/listarPorLogin/', body)
        this.LISTA_CONTAS = response.data || []
        // Seleciona todas por padrão se o usuário quiser, ou deixa vazio para forçar seleção
      } catch (error) {
        console.error('Erro ao carregar contas', error)
      }
    },

    toggleSelectAllContas: function() {
      if (this.CONTAS_SELECIONADAS.length === this.LISTA_CONTAS.length) {
        this.CONTAS_SELECIONADAS = []
      } else {
        this.CONTAS_SELECIONADAS = this.LISTA_CONTAS.map(c => c.CODIGO)
      }
    },

    imprimir: async function() {
      if (this.loading) return
      if (this.CONTAS_SELECIONADAS.length === 0) {
        tools.exibirMensagem(this.$store, 'Selecione ao menos uma conta bancária', 'warning')
        return
      }

      this.loading = true
      this.$store.commit('controle/setAguardando', true)

      try {
        const params = {
          dt1: this.DT1,
          dt2: this.DT2,
          contaId: this.CONTAS_SELECIONADAS.join(','),
          historicoId: this.HISTORICO_ID || '',
          centroCustoId: this.CENTRO_CUSTO_ID || '',
          clienteId: this.CLIENTE_ID || '',
          tipo: this.TIPO_MOV || ''
        }

        let endpoint = '/api/protected/caixa/relatorio/relViewRelCaixaItens'
        if (this.tipoRelatorio === '2') endpoint = '/api/protected/caixa/relatorio/relAcumuladoHistorico'
        else if (this.tipoRelatorio === '3') endpoint = '/api/protected/caixa/relatorio/relAcumuladoCentroCusto'
        else if (this.tipoRelatorio === '4') endpoint = '/api/protected/caixa/relatorio/relAcumuladoBanco'
        
        // Ajuste de tipo para extratos específicos
        if (this.tipoRelatorio === '5') params.tipo = 'DEBITO'
        if (this.tipoRelatorio === '6') params.tipo = 'CREDITO'

        const response = await this.$http.get(endpoint, { params })
        const data = response.data

        if (!data || data.length === 0) {
          tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Nenhuma informação para o filtro selecionado')
          return
        }

        const titulo = this.opcoesRelatorio.find(o => o.value === this.tipoRelatorio).text
        this.gerarRelatorio(data, titulo)

      } catch (error) {
        tools.exibirMensagem(this.$store, 'Erro ao gerar relatório', 'danger', error)
      } finally {
        this.loading = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    getCommonHeader: function(titulo) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      const nomeEmpresa = window.localStorage.getItem('nomeempresa') || 'CECWEB'
      const dataHora = new Date().toLocaleString('pt-BR')
      
      const contasNomes = this.LISTA_CONTAS
        .filter(c => this.CONTAS_SELECIONADAS.includes(c.CODIGO))
        .map(c => c.NOME_CONTA)
        .join(', ')

      // Filtros opcionais
      let extraFilters = []
      if (this.TIPO_MOV) extraFilters.push(`<strong>Tipo:</strong> ${this.TIPO_MOV}`)
      if (this.CLIENTE_ID) {
        const clienteNome = this.$refs.clientepesquisa ? this.$refs.clientepesquisa.getDescricao() : 'Selecionado'
        extraFilters.push(`<strong>Cliente/Fornec.:</strong> ${clienteNome}`)
      }
      
      // Para historico e centro de custo, tentamos pegar o texto se disponível
      if (this.HISTORICO_ID) extraFilters.push(`<strong>Histórico:</strong> ${this.HISTORICO_NOME || this.HISTORICO_ID}`)
      if (this.CENTRO_CUSTO_ID) extraFilters.push(`<strong>Centro de Custo:</strong> ${this.CENTRO_CUSTO_NOME || this.CENTRO_CUSTO_ID}`)

      const extraFiltersHtml = extraFilters.length > 0 ? `
        <div class="report-header-sub">
          <div>${extraFilters.join(' | ')}</div>
        </div>
      ` : ''

      return `
        <div class="report-header">
          <div class="report-header-top">
            <div><strong>${nomeEmpresa}</strong></div>
            <div><strong>Usuário:</strong> ${nomeUsuario}</div>
          </div>
          <div class="report-header-title">${titulo}</div>
          <div class="report-header-sub">
            <div><strong>Período:</strong> ${tools.formatarDataBR(this.DT1)} até ${tools.formatarDataBR(this.DT2)}</div>
            <div><strong>Contas:</strong> ${contasNomes}</div>
          </div>
          ${extraFiltersHtml}
          <div class="report-header-sub">
            <div><strong>Emitido em:</strong> ${dataHora}</div>
          </div>
        </div>
      `
    },

    getCommonFooter: function(data, totalItens) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      const dataHora = new Date().toLocaleString('pt-BR')
      
      // Agrupar totais por Forma de Pagamento
      const totaisPorForma = {}
      let totalCredito = 0
      let totalDebito = 0

      data.forEach(item => {
        const forma = item.FORMA || 'NÃO INFORMADO'
        const valor = Math.abs(parseFloat(item.VL_MOV || 0))
        const tipo = (item.TIPO_MOV || '').toUpperCase()
        
        if (tipo === 'CREDITO') {
          totalCredito += valor
        } else if (tipo === 'DEBITO') {
          totalDebito += valor
        }

        if (!totaisPorForma[forma]) totaisPorForma[forma] = 0
        totaisPorForma[forma] += (valor * (tipo === 'DEBITO' ? -1 : 1))
      })

      const saldoGeral = totalCredito - totalDebito

      let formaHtml = Object.keys(totaisPorForma).map(forma => `
        <div class="footer-stat">
          <strong>${forma}:</strong> ${tools.formatCurrency(Math.abs(totaisPorForma[forma]))} ${totaisPorForma[forma] < 0 ? '(D)' : '(C)'}
        </div>
      `).join('')

      return `
        <div class="report-footer-stats">
          <div style="display: grid; grid-template-columns: 1fr 2fr; gap: 20px;">
            <div>
              <div class="footer-stats-title">Resumo de Movimentação</div>
              <div class="footer-stat"><strong>Total Créditos:</strong> <span class="badge-cr">${tools.formatCurrency(totalCredito)}</span></div>
              <div class="footer-stat"><strong>Total Débitos:</strong> <span class="badge-db">${tools.formatCurrency(totalDebito)}</span></div>
              <div class="footer-stat" style="border-top: 1px solid #000; margin-top: 5px; padding-top: 5px;">
                <strong>Saldo Geral:</strong> <span class="${saldoGeral < 0 ? 'badge-db' : 'badge-cr'}">${tools.formatCurrency(Math.abs(saldoGeral))} ${saldoGeral < 0 ? '(DEVEDOR)' : '(CREDOR)'}</span>
              </div>
            </div>
            <div>
              <div class="footer-stats-title">Resumo por Forma de Pagamento</div>
              <div class="footer-stats-grid">${formaHtml}</div>
            </div>
          </div>
        </div>
        <div class="report-footer">
          <div>CECFrigo - Controle Comercial e Industrial</div>
          <div>Qtd. registros: ${totalItens}</div>
          <div>Usuário: ${nomeUsuario} | ${dataHora}</div>
        </div>
      `
    },

    getCommonStyles: function(landscape) {
      const orientation = landscape ? 'landscape' : 'portrait'
      return `
        <style>
          @page { size: A4 ${orientation}; margin: 15mm 12mm 12mm 18mm; }
          body { font-family: Arial, sans-serif; margin: 0; padding: 0; color: #111; font-size: 10px; }
          .report-container { width: 100%; }
          .report-header { border: 1px solid #000; margin-bottom: 10px; }
          .report-header-top, .report-header-sub { display: flex; justify-content: space-between; padding: 3px 6px; border-bottom: 1px solid #000; }
          .report-header-sub:last-child { border-bottom: none; }
          .report-header-title { padding: 5px; font-size: 12px; font-weight: bold; text-align: center; border-bottom: 1px solid #000; background: #f0f0f0; }
          .grid-main { width: 100%; border-collapse: collapse; margin-top: 5px; table-layout: fixed; }
          .grid-main th, .grid-main td { border: 1px solid #000; padding: 4px; vertical-align: middle; word-wrap: break-word; }
          .grid-main th { background: #eee; font-weight: bold; text-align: left; text-transform: uppercase; font-size: 9px; }
          .text-right { text-align: right; }
          .text-center { text-align: center; }
          .font-bold { font-weight: bold; }
          .badge-cr { color: green; font-weight: bold; }
          .badge-db { color: red; font-weight: bold; }
          .group-header { background: #f9f9f9; font-weight: bold; padding: 5px; border: 1px solid #000; margin-top: 10px; }
          .report-footer-stats { margin-top: 20px; border: 1px solid #000; padding: 10px; page-break-inside: avoid; }
          .footer-stats-title { font-weight: bold; border-bottom: 1px solid #000; margin-bottom: 5px; padding-bottom: 3px; text-transform: uppercase; }
          .footer-stats-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
          .report-footer { margin-top: 10px; display: flex; justify-content: space-between; font-size: 8px; border-top: 1px dashed #666; padding-top: 5px; }
        </style>
      `
    },

    gerarRelatorio: function(data, titulo) {
      let content = ''
      let landscape = true

      if (['1', '5', '6'].includes(this.tipoRelatorio)) {
        // Analítico Geral / Extratos
        content = this.renderTabelaAnalitica(data)
      } else if (['2', '3', '4'].includes(this.tipoRelatorio)) {
        // Sintéticos
        landscape = false
        content = this.renderTabelaSintetica(data)
      } else if (this.tipoRelatorio === '7') {
        // Agrupado por Centro de Custo
        content = this.renderTabelaAgrupada(data, 'NOME_CENTRO', 'Centro de Custo')
      } else if (this.tipoRelatorio === '8') {
        // Agrupado por Histórico
        content = this.renderTabelaAgrupada(data, 'NOME_PLANO', 'Histórico')
      }

      const html = `
        <!doctype html>
        <html lang="pt-BR">
        <head>
          <meta charset="utf-8">
          <title>${titulo}</title>
          ${this.getCommonStyles(landscape)}
        </head>
        <body>
          <div class="report-container">
            ${this.getCommonHeader(titulo.toUpperCase())}
            ${content}
            ${this.getCommonFooter(data, data.length)}
          </div>
        </body>
        </html>
      `
      RelatorioHTML.imprimir(html, titulo, 'A4', landscape ? 'landscape' : 'portrait')
    },

    renderTabelaAnalitica: function(data) {
      let rows = data.map(p => `
        <tr>
          <td width="40" align="center">${p.SEQUENCIA || p.ID || ''}</td>
          <td width="65" align="center">${tools.formatarDataBR(p.DT_MOV)}</td>
          <td width="60" align="center">${p.COD_CONTA || ''}</td>
          <td width="70">${p.DOCUMENTO || ''}</td>
          <td>${p.NOME_PLANO || ''}</td>
          <td>${p.NOME_CLIENTE || ''}</td>
          <td>${p.OBS || ''}</td>
          <td width="80" align="right" class="font-bold">${tools.formatCurrency(p.VL_MOV)}</td>
          <td width="30" align="center" class="${p.TIPO_MOV === 'CREDITO' ? 'badge-cr' : 'badge-db'}">${p.TIPO_MOV === 'CREDITO' ? 'CR' : 'DB'}</td>
        </tr>
      `).join('')

      return `
        <table class="grid-main">
          <thead>
            <tr>
              <th width="40">ID</th><th width="65">DATA</th><th width="60">CONTA</th><th width="70">DOC</th>
              <th>HISTÓRICO</th><th>CLIENTE/FORNECEDOR</th><th>DESCRIÇÃO</th><th width="80" align="right">VALOR</th><th width="30">TIPO</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      `
    },

    renderTabelaSintetica: function(data) {
      let rows = data.map(p => `
        <tr>
          <td>${p.NOME_PLANO || p.NOME_CENTRO || p.NOME_CONTA || ''}</td>
          <td width="80" align="center" class="${p.TIPO_MOV === 'CREDITO' ? 'badge-cr' : 'badge-db'}">${p.TIPO_MOV || ''}</td>
          <td width="100" align="right" class="font-bold">${tools.formatCurrency(p.VL_MOV)}</td>
        </tr>
      `).join('')

      const label = this.tipoRelatorio === '2' ? 'HISTÓRICO' : (this.tipoRelatorio === '3' ? 'CENTRO DE CUSTO' : 'CONTA')

      return `
        <table class="grid-main">
          <thead>
            <tr>
              <th>${label}</th><th width="80" align="center">TIPO</th><th width="100" align="right">TOTAL</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      `
    },

    renderTabelaAgrupada: function(data, campoAgrupar, labelAgrupar) {
      const grupos = {}
      data.forEach(item => {
        const chave = item[campoAgrupar] || 'NÃO DEFINIDO'
        if (!grupos[chave]) grupos[chave] = []
        grupos[chave].push(item)
      })

      return Object.keys(grupos).map(chave => {
        const rows = grupos[chave].map(p => `
          <tr>
            <td width="65" align="center">${tools.formatarDataBR(p.DT_MOV)}</td>
            <td width="60" align="center">${p.COD_CONTA || ''}</td>
            <td width="70">${p.DOCUMENTO || ''}</td>
            <td>${this.tipoRelatorio === '7' ? p.NOME_PLANO : p.NOME_CENTRO}</td>
            <td>${p.NOME_CLIENTE || ''}</td>
            <td>${p.OBS || ''}</td>
            <td width="80" align="right" class="font-bold">${tools.formatCurrency(p.VL_MOV)}</td>
            <td width="30" align="center" class="${p.TIPO_MOV === 'CREDITO' ? 'badge-cr' : 'badge-db'}">${p.TIPO_MOV === 'CREDITO' ? 'CR' : 'DB'}</td>
          </tr>
        `).join('')

        const totalGrupo = grupos[chave].reduce((acc, curr) => acc + (parseFloat(curr.VL_MOV) * (curr.TIPO_MOV === 'DEBITO' ? -1 : 1)), 0)

        return `
          <div class="group-header">${labelAgrupar}: ${chave}</div>
          <table class="grid-main">
            <thead>
              <tr>
                <th width="65">DATA</th><th width="60">CONTA</th><th width="70">DOC</th>
                <th>${this.tipoRelatorio === '7' ? 'HISTÓRICO' : 'CENTRO DE CUSTO'}</th>
                <th>CLIENTE/FORNECEDOR</th><th>DESCRIÇÃO</th><th width="80" align="right">VALOR</th><th width="30">TIPO</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
            <tfoot>
              <tr>
                <td colspan="6" align="right"><strong>SUBTOTAL DO GRUPO:</strong></td>
                <td align="right"><strong>${tools.formatCurrency(Math.abs(totalGrupo))}</strong></td>
                <td align="center"><strong>${totalGrupo < 0 ? 'DB' : 'CR'}</strong></td>
              </tr>
            </tfoot>
          </table>
        `
      }).join('')
    }
  }
}
</script>

<template>
  <div class="animated fadeIn">
    <form @submit.prevent="imprimir">
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            
            <div class="p-4 d-flex align-items-center justify-content-between" 
                 :class="isDark ? 'bg-secondary-soft' : 'bg-primary-soft'">
              <div>
                <h4 class="mb-1 font-weight-bold" :class="isDark ? 'text-white' : 'text-primary'">
                  <i class='fa fa-university mr-2'></i>Relatórios de Lançamentos de Caixa
                </h4>
                <span class="text-muted d-block">Analise suas movimentações financeiras, fluxos de caixa e acumulados por categoria.</span>
              </div>
            </div>

            <b-row class="mt-4">
              <b-col md="4" sm="12">
                <div class="section-container h-100" :class="isDark ? 'dark-mode' : ''">
                  <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatório</h6>
                  <b-form-group label-for="tipoRelatorio" description="Selecione o modelo de relatório desejado.">
                    <b-form-select 
                      id="tipoRelatorio"
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      class="form-control-lg select-premium"
                    />
                  </b-form-group>

                  <div class="mt-4">
                    <h6 class="section-title-small"><i class="fa fa-calendar mr-2"></i>Período</h6>
                    <b-row>
                      <b-col md="6">
                        <b-form-group label="Data Início">
                          <cec-input-data v-model="DT1" />
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group label="Data Fim">
                          <cec-input-data v-model="DT2" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>

              <b-col md="4" sm="12">
                <div class="section-container h-100" :class="isDark ? 'dark-mode' : ''">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-university mr-2"></i>Contas Bancárias</h6>
                    <b-button size="sm" variant="outline-primary" pill @click="toggleSelectAllContas">
                      {{ CONTAS_SELECIONADAS.length === LISTA_CONTAS.length ? 'Desmarcar Todas' : 'Marcar Todas' }}
                    </b-button>
                  </div>
                  <div class="contas-scroll-container mt-3">
                    <b-form-checkbox-group
                      v-model="CONTAS_SELECIONADAS"
                      stacked
                    >
                      <div v-for="conta in LISTA_CONTAS" :key="conta.CODIGO" class="conta-item-check p-2 mb-1 rounded">
                        <b-form-checkbox :value="conta.CODIGO">
                          <span class="font-weight-bold">{{ conta.CODIGO }}</span> - {{ conta.NOME_CONTA }}
                        </b-form-checkbox>
                      </div>
                    </b-form-checkbox-group>
                  </div>
                  <small class="text-danger mt-2 d-block" v-if="CONTAS_SELECIONADAS.length === 0">
                    * Seleção obrigatória de ao menos uma conta.
                  </small>
                </div>
              </b-col>

              <b-col md="4" sm="12">
                <div class="section-container h-100" :class="isDark ? 'dark-mode' : ''">
                  <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-filter mr-2"></i>Filtros de Refinamento</h6>
                  
                  <b-form-group label="Tipo de Movimentação" v-if="filtrosHabilitados.tipo">
                    <b-form-select 
                      v-model="TIPO_MOV"
                      :options="opcoesTipo"
                      :plain="true"
                    />
                  </b-form-group>

                  <b-form-group label="Histórico / Plano de Contas" v-if="filtrosHabilitados.historico">
                    <historico-caixa-dropdown
                      v-model="HISTORICO_ID"
                      placeholder="Todos os históricos"
                      @retornaObjeto="HISTORICO_NOME = $event ? $event.text : ''"
                    />
                  </b-form-group>

                  <b-form-group label="Centro de Custo" v-if="filtrosHabilitados.centroCusto">
                    <centro-custo-drop-down 
                      v-model="CENTRO_CUSTO_ID"
                      placeholder="Todas as unidades"
                      @retornaObjeto="CENTRO_CUSTO_NOME = $event ? $event.text : ''"
                    />
                  </b-form-group>

                  <b-form-group label="Cliente / Fornecedor">
                    <cliente-pesquisa 
                      @retornaId="CLIENTE_ID = $event"
                      :idInicial="CLIENTE_ID"
                      place="Opcional: Pesquise pelo nome..."
                      labelBotao=""
                      ref="clientepesquisa"
                      idModal="clientepesquisa"
                    />
                  </b-form-group>
                </div>
              </b-col>
            </b-row>

            <div slot="footer" class="p-3">
              <b-row class="justify-content-center">
                <b-col md="4" sm="12">
                  <b-button 
                    type="submit" 
                    variant="primary" 
                    block 
                    size="lg" 
                    class="btn-premium shadow"
                    :disabled="loading || CONTAS_SELECIONADAS.length === 0">
                    <i class="fa fa-print mr-2"></i>{{ loading ? 'PROCESSANDO...' : 'GERAR RELATÓRIO' }}
                  </b-button>
                </b-col>
              </b-row>
            </div>

          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<style scoped>
.bg-primary-soft { background-color: #e8f0fe; }
.bg-secondary-soft { background-color: #3e444a; }
.select-premium {
  border: 1.5px solid #ced4da;
  border-radius: 8px;
  transition: all 0.2s;
  background-color: #fff;
}
.select-premium:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}
.section-container {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  background: #fdfdfd;
  position: relative;
}
.section-container.dark-mode {
  background: #2c2c2c;
  border-color: #444;
}
.section-title {
  position: absolute;
  top: -12px;
  left: 20px;
  background: #fff;
  padding: 0 10px;
  font-weight: bold;
  color: #666;
  font-size: 0.85rem;
  text-transform: uppercase;
}
.section-title.dark-mode {
  background: #2c2c2c;
  color: #aaa;
}
.section-title-small {
  font-weight: bold;
  color: #888;
  font-size: 0.75rem;
  text-transform: uppercase;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}
.contas-scroll-container {
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 5px;
  background: #fff;
}
.conta-item-check {
  transition: all 0.2s;
  border: 1px solid transparent;
}
.conta-item-check:hover {
  background: #f0f7ff;
  border-color: #cfe2ff;
}
.btn-premium {
  border-radius: 10px;
  font-weight: bold;
  letter-spacing: 0.5px;
  transition: all 0.3s;
}
.btn-premium:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 123, 255, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelCaixa.vue